
export function StoreSS(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value))
}

export function GetSS(key: string) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
        return null
    }
    return JSON.parse(itemStr)
}

export function DeleteSS(key: string) {
    localStorage.removeItem(key);
}